<template>
  <AnalyticsWidget
    title="Financial Breakdown"
    subTitle="New orders and invoices created during the date ranges"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">

    <LoadingPanel :loading="loading" />
    <AnalyticsBreakdownTable v-if="!loading">
      <template v-slot:header>
        <tr>
          <th></th>
          <th v-if="showOrderBreakdown">Orders</th>
          <th v-if="showOrderBreakdown">Order Count</th>
          <th v-if="showInvoiceBreakdown">Invoice Total</th>
          <th v-if="showInvoiceBreakdown">Invoice Count</th>
        </tr>
      </template>
      <!-- TODO: Use inline popovers instead to show date ranges -->
      <template v-slot:body>
        <tr v-if="showOrderBreakdown || showInvoiceBreakdown" class="highlight">
          <td><Tooltip helpStyle label="Today's value compared to previous working day">Today</Tooltip></td>
          <AnalyticsBreakdownValueCell v-if="showOrderBreakdown" :value="orderBreakdownData.day.current.orderValue" :previous="orderBreakdownData.day.previous.orderValue" highlight>{{formatCurrency(orderBreakdownData.day.current.orderValue)}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell v-if="showOrderBreakdown" :value="orderBreakdownData.day.current.orderCount" :previous="orderBreakdownData.day.previous.orderCount">{{orderBreakdownData.day.current.orderCount}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell v-if="showInvoiceBreakdown" :value="invoiceBreakdownData.day.current.invoiceValue" :previous="invoiceBreakdownData.day.previous.invoiceValue" highlight>{{formatCurrency(invoiceBreakdownData.day.current.invoiceValue)}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell v-if="showInvoiceBreakdown" :value="invoiceBreakdownData.day.current.invoiceCount" :previous="invoiceBreakdownData.day.previous.invoiceCount">{{invoiceBreakdownData.day.current.invoiceCount}}</AnalyticsBreakdownValueCell>
        </tr>
        <tr v-if="showOrderBreakdown || showInvoiceBreakdown">
          <td><Tooltip helpStyle label="This week compared to same day last week">This Week</Tooltip></td>
          <AnalyticsBreakdownValueCell v-if="showOrderBreakdown" :value="orderBreakdownData.week.current.orderValue" :previous="orderBreakdownData.week.previous.orderValue">{{formatCurrency(orderBreakdownData.week.current.orderValue)}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell v-if="showOrderBreakdown" :value="orderBreakdownData.week.current.orderCount" :previous="orderBreakdownData.week.previous.orderCount">{{orderBreakdownData.week.current.orderCount}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell v-if="showInvoiceBreakdown" :value="invoiceBreakdownData.week.current.invoiceValue" :previous="invoiceBreakdownData.week.previous.invoiceValue">{{formatCurrency(invoiceBreakdownData.week.current.invoiceValue)}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell v-if="showInvoiceBreakdown" :value="invoiceBreakdownData.week.current.invoiceCount" :previous="invoiceBreakdownData.week.previous.invoiceCount">{{invoiceBreakdownData.week.current.invoiceCount}}</AnalyticsBreakdownValueCell>
        </tr>
        <tr v-if="showOrderBreakdown || showInvoiceBreakdown">
          <td><Tooltip helpStyle label="This month compared to same day last month">This Month</Tooltip></td>
          <AnalyticsBreakdownValueCell v-if="showOrderBreakdown" :value="orderBreakdownData.month.current.orderValue" :previous="orderBreakdownData.month.previous.orderValue">{{formatCurrency(orderBreakdownData.month.current.orderValue)}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell v-if="showOrderBreakdown" :value="orderBreakdownData.month.current.orderCount" :previous="orderBreakdownData.month.previous.orderCount">{{orderBreakdownData.month.current.orderCount}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell v-if="showInvoiceBreakdown" :value="invoiceBreakdownData.month.current.invoiceValue" :previous="invoiceBreakdownData.month.previous.invoiceValue">{{formatCurrency(invoiceBreakdownData.month.current.invoiceValue)}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell v-if="showInvoiceBreakdown" :value="invoiceBreakdownData.month.current.invoiceCount" :previous="invoiceBreakdownData.month.previous.invoiceCount">{{invoiceBreakdownData.month.current.invoiceCount}}</AnalyticsBreakdownValueCell>
        </tr>
        <tr v-if="showOrderBreakdown || showInvoiceBreakdown">
          <td><Tooltip helpStyle label="This financial year compared to same day last financial year">This FY</Tooltip></td>
          <AnalyticsBreakdownValueCell v-if="showOrderBreakdown" :value="orderBreakdownData.financialYear.current.orderValue" :previous="orderBreakdownData.financialYear.previous.orderValue">{{formatCurrency(orderBreakdownData.financialYear.current.orderValue)}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell v-if="showOrderBreakdown" :value="orderBreakdownData.financialYear.current.orderCount" :previous="orderBreakdownData.financialYear.previous.orderCount">{{orderBreakdownData.financialYear.current.orderCount}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell v-if="showInvoiceBreakdown" :value="invoiceBreakdownData.financialYear.current.invoiceValue" :previous="invoiceBreakdownData.financialYear.previous.invoiceValue">{{formatCurrency(invoiceBreakdownData.financialYear.current.invoiceValue)}}</AnalyticsBreakdownValueCell>
          <AnalyticsBreakdownValueCell v-if="showInvoiceBreakdown" :value="invoiceBreakdownData.financialYear.current.invoiceCount" :previous="invoiceBreakdownData.financialYear.previous.invoiceCount">{{invoiceBreakdownData.financialYear.current.invoiceCount}}</AnalyticsBreakdownValueCell>
        </tr>
      </template>

    </AnalyticsBreakdownTable>
  </AnalyticsWidget>
</template>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsBreakdownTable from '@/modules/intelligence/components/analyticsBreakdownTable'
import AnalyticsBreakdownValueCell from '@/modules/intelligence/components/analyticsBreakdownValueCell'

export default {
  name: 'FinancialBreakdownWidget',
  components: {
    AnalyticsWidget,
    AnalyticsBreakdownTable,
    AnalyticsBreakdownValueCell
  },
  props: {
    filter: Object,
    contactId: Number,
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    hasContactFilter() {
      return this.contactId != null
    },
    showOrderBreakdown() {
      return this.userHasReadPermission(this.PermissionTypes.IntelligencePermissionTypes.intelligenceOrder) && this.orderBreakdownData.day
    },
    showInvoiceBreakdown() {
      return this.userHasReadPermission(this.PermissionTypes.IntelligencePermissionTypes.intelligenceAccount) && this.invoiceBreakdownData.day
    }
  },
  data() {
    return {
      loading: true,
      orderBreakdownData: {},
      invoiceBreakdownData: {}
    }
  },
  watch: {
    contactId: function() {
      this.requestData()
    },
    filter: function() {
      this.requestData()
    }
  },
  mounted() {
    this.loading = true
    this.requestData()

    this.subscribeEndpoint('/orders', () => {
      this.requestData()
    })
    this.subscribeEndpoint('/accounts/invoices', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/orders')
    this.unsubscribeEndpoint('/accounts/invoices')
  },
  methods: {
    requestData() {
      var params = {
        contactId: this.contactId,
        accountLocationId: this.filter ? this.filter.accountLocationIdList : null
      }

      this.$apiService.analyticsService.getOrdersValueBreakdown(params)
      .then(response => {
        this.orderBreakdownData = response.data
      })
      .finally(() => {
        this.loading = false
      })
      .catch(err => {
      })

      this.$apiService.analyticsService.getInvoiceValueBreakdown(params)
      .then(response => {
        this.invoiceBreakdownData = response.data
      })
      .finally(() => {
        this.loading = false
      })
      .catch(err => {
      })
    }
  }
}
</script>